export default {
  created: 0,
  active: 2,
  completed: 3,
  error: 4,
};
